import type { ButtonProps} from '@chakra-ui/react'
import { Button, forwardRef } from '@chakra-ui/react'

export interface WizzardHeaderButtonProps extends ButtonProps { }

export const WizzardHeaderButton = forwardRef(
  ({ children, sx, ...rest }: WizzardHeaderButtonProps, ref) => {
    return (
      <Button
        ref={ref}
        sx={{
          px: {
            base: 2,
            xl: 6,
          },
          textAlign: 'center',
          width: '100%',
          ...sx,
        }}
        colorScheme="primary"
        {...rest}
      >
        {children}
      </Button>
    )
  },
)
